export const niisevents = [
  {
    id: 1,
    imageUrl: require("../assets/niis-events/event 1.JPG"),
    title: "NIIS E-Sports Arena",
    status: "Active",
    date: "Coming soon",
    duration: "5 days",
    person: "Rebound",
    price: 250,
  },
  {
    id: 2,
    title: "International Conference",
    status: "Active",
    date: "Coming soon",
    duration: "5 days",
    person: "60",
    price: 250,
  },
];
